import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import { useAuth } from '../context/AuthContext';
import WalletModal from './WalletModal';
import '../styles/navbar.css';

const Navbar = () => {
  const { account, connectWallet, disconnectWallet, formatAddress } = useWallet();
  const { currentUser, logout } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isWalletModalOpen, setIsWalletModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    // Implement search functionality
    console.log('Searching for:', searchQuery);
    // Redirect to marketplace with search query
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const openWalletModal = () => {
    setIsWalletModalOpen(true);
  };

  const closeWalletModal = () => {
    setIsWalletModalOpen(false);
  };

  const handleSuccessfulConnection = () => {
    closeWalletModal();
  };

  const handleLogout = () => {
    logout();
    disconnectWallet();
    navigate('/');
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <Link to="/">
              <span className="logo-text">DataHarbor</span>
            </Link>
          </div>

          <div className="search-container">
            <form onSubmit={handleSearch}>
              <input
                type="text"
                placeholder="Search datasets..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
              />
              <button type="submit" className="search-button">
                <i className="fas fa-search"></i>
              </button>
            </form>
          </div>

          <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>

          <ul className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
            <li className={`navbar-item ${location.pathname === '/' ? 'active' : ''}`}>
              <Link to="/" className="navbar-link">Home</Link>
            </li>
            <li className={`navbar-item ${location.pathname === '/marketplace' ? 'active' : ''}`}>
              <Link to="/marketplace" className="navbar-link">Datasets</Link>
            </li>
            {currentUser && (
              <li className={`navbar-item ${location.pathname === '/upload' ? 'active' : ''}`}>
                <Link to="/upload" className="navbar-link">Upload</Link>
              </li>
            )}
            <li className="navbar-item dropdown">
              <span className="navbar-link dropdown-toggle">Community</span>
              <div className="dropdown-menu">
                <Link to="/discussions" className="dropdown-item">Discussions</Link>
                <Link to="/leaderboard" className="dropdown-item">Leaderboard</Link>
                <Link to="/docs" className="dropdown-item">Documentation</Link>
              </div>
            </li>
            {currentUser && (
              <li className={`navbar-item ${location.pathname === '/profile' ? 'active' : ''}`}>
                <Link to="/profile" className="navbar-link">My Profile</Link>
              </li>
            )}
          </ul>

          <div className="wallet-connection">
            {currentUser ? (
              <div className="user-menu">
                {account ? (
                  <div className="wallet-info">
                    <span className="wallet-address">{formatAddress(account)}</span>
                  </div>
                ) : (
                  <button
                    className="btn btn-primary connect-btn"
                    onClick={openWalletModal}
                  >
                    <i className="fas fa-wallet"></i> Connect Wallet
                  </button>
                )}
                <div className="user-info">
                  <span className="user-name">{currentUser.name}</span>
                  <button
                    className="btn btn-secondary logout-btn"
                    onClick={handleLogout}
                  >
                    Sign Out
                  </button>
                </div>
              </div>
            ) : (
              <div className="auth-buttons">
                <Link to="/login" className="btn btn-secondary login-btn">
                  Sign In
                </Link>
                <Link to="/signup" className="btn btn-primary signup-btn">
                  Sign Up
                </Link>
              </div>
            )}
          </div>
        </div>
      </nav>

      <WalletModal
        isOpen={isWalletModalOpen}
        onClose={closeWalletModal}
        onSuccess={handleSuccessfulConnection}
      />
    </>
  );
};

export default Navbar;
